export default "__VITE_ASSET__CRPAnuBe__"